module.exports = __webpack_public_path__ + "AvenirNextCondensed-Bold.ttf";